import React from "react";
import { ConfigProvider, Button, Modal, Image } from "antd";
import {
  textTitleProfile,
  textDescProfile,
  textSelectedTabs,
  colorTabsIndicator,
  borderBtnFocus,
  colorAlertOverdueJourney,
  colorTextDesc,
  colorTextTitleMobile,
} from "../../../../../../../../config/constant/color/index";
import ModalDetailCourseMobileContent from "./ModalDetailCourseMobileContent";
import { useTranslation } from "react-i18next";
import { WarningFilled } from "@ant-design/icons";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

const ModalDetailCourseMobile = ({ isOpen, onClose, data }) => {
  const { t, i18n } = useTranslation();

  const screens = useBreakpoint();
  const isMobileVersion = screens.xs;
  const isScallingVersion =
    (window.innerWidth <= 991 && window.innerWidth >= 768) ||
    window.innerWidth === 581;

  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            inkBarColor: colorTabsIndicator,
            itemSelectedColor: textSelectedTabs,
            itemColor: textDescProfile,
            horizontalItemPadding: "0 12px 14px 12px",
          },
        },
        token: {
          fontFamily: "Roboto",
          colorPrimaryHover: borderBtnFocus,
          colorPrimaryActive: borderBtnFocus,
          borderRadiusLG: 16,
        },
      }}
    >
      <Modal
        className="modal-detail-course-mobile"
        open={isOpen}
        maskClosable={false}
        transitionName="ant-fade"
        width={
          isMobileVersion ? "90%" : isScallingVersion ? `${585 * 0.9}px` : "90%"
        }
        keyboard
        closable={false}
        centered
        footer={null}
        style={{ borderRadius: "16px" }}
      >
        <div style={{ padding: "20px 0 20px 18px" }}>
          <div
            style={{
              height: "500px",
              overflowY: "auto",
              overflowX: "hidden",
              marginBottom: "20px",
              paddingRight: "18px",
            }}
          >
            <ModalDetailCourseMobileContent
              loading={false}
              wraperStyle={null}
              rowImageStyle={{
                width: "100%",
                height: "100%",
                marginBottom: "16px",
              }}
              index={data.sort}
              thumbnail={
                <Image
                  width={"100%"}
                  height={"100%"}
                  style={{
                    borderRadius: "8px",
                    objectFit: "fill",
                    height: "100%",
                  }}
                  src={data.thumbnail}
                  preview={false}
                  alt="Course Thumbnail Mobile"
                />
              }
              divRightStyle={{
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
              pProgramStyle={{
                fontSize: "10px",
                marginBottom: "0px",
                fontWeight: "400",
                color: colorTextDesc,
              }}
              titleJourneyDescStyle={{
                fontSize: "18px",
                fontWeight: "500",
                color: colorTextTitleMobile,
                marginRight: "8px",
              }}
              journeyName={data.name}
              rowBottomFirstStyle={null}
              rowBottomSecondStyle={{
                display: "flex",
                alignItems: "flex-end",
              }}
              pointImageWidth={16}
              totalPoint={
                data.point !== null && data.point !== undefined ? (
                  parseInt(data.point) < 2 ? (
                    <span
                      style={{
                        color: textTitleProfile,
                        fontWeight: "500",
                        margin: "0 5px",
                        lineHeight: "normal",
                      }}
                    >
                      {data.point} {t("feature.feature_tm.point_earned")}
                    </span>
                  ) : (
                    <span
                      style={{
                        color: textTitleProfile,
                        fontWeight: "500",
                        margin: "0 5px",
                        lineHeight: "normal",
                      }}
                    >
                      {data.point} {t("feature.feature_tm.points_earned")}
                    </span>
                  )
                ) : (
                  <span
                    style={{
                      color: textTitleProfile,
                      fontWeight: "500",
                      margin: "0 5px",
                      lineHeight: "normal",
                    }}
                  >
                    -
                  </span>
                )
              }
              moduleType={data.module_type}
              dividerStyle={{ margin: "20px 0" }}
              desc={
                data.description != "" ? (
                  <div
                    style={{
                      textAlign: "left",
                      lineHeight: "22px",
                      whiteSpace: "pre-wrap",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: textDescProfile,
                      marginTop: "16px",
                    }}
                  >
                    {data.description}
                  </div>
                ) : (
                  ""
                )
              }
              overDue={
                <div
                  style={{
                    backgroundColor: colorAlertOverdueJourney,
                    borderRadius: "6px",
                    padding: "2px 6px",
                    width: "fit-content",
                    display:
                      data.journeyDaysLeft !== null &&
                      data.currJourneyData !== null &&
                      data.currJourneyData !== undefined &&
                      data.currJourneyData.is_completed !== 1
                        ? "block"
                        : "none",
                  }}
                >
                  <WarningFilled style={{ color: "#FFFFFF" }} />
                  <span
                    style={{
                      color: "#FFFFFF",
                      fontWeight: "bold",
                      marginLeft: "3px",
                      fontSize: "12px",
                    }}
                  >
                    {data.journeyDaysLeft > 0 ? (
                      data.journeyDaysLeft < 2 ? (
                        <>{data.journeyDaysLeft} Day left</>
                      ) : (
                        <>
                          {data.journeyDaysLeft}{" "}
                          {t(
                            "feature.feature_mylj.main_content.days_left_program",
                          )}
                        </>
                      )
                    ) : (
                      <>{t("feature.feature_mylj.anchor.overdue")}</>
                    )}
                  </span>
                </div>
              }
            />
          </div>
          <div style={{ paddingRight: "18px" }}>
            <Button
              className="btn btn-primary"
              block
              style={{
                fontSize: "14px",
                fontWeight: "500",
                borderRadius: "6px",
                height: "40px",
              }}
              id="btn-close-modal-course"
              onClick={() => {
                onClose();
              }}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ModalDetailCourseMobile;
